import React from 'react'
import './styles/layout-brand.css'
import { createTheme, ThemeProvider } from '@mui/material/styles'

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom'
import { useAppDispatch } from './app/hooks'
import { authReceiveToken } from './modules/auth/authSlice'
import ProtectedRoute from './modules/auth/provider/ProtectedRoute'
import AuthLoginPage from './modules/auth/pages/AuthLoginPage'
import DashboardLayout from './modules/dashboard/layout/DashboardLayout'
import DashboardHome from './modules/dashboard/pages/DashboardHome'
import { AuthProvider } from './modules/auth/provider/AuthProvider'
import { getLoginResponseFromLocalStorage } from './modules/auth/authLocalStorageMiddleware'
import VerifyDisbursementAccountPage from './modules/dashboard/pages/VerifyDisbursementAccount'
// import VerifyIdentityPage from './modules/dashboard/pages/VerifyIdentityPage'
import ResetPasswordPage from './modules/auth/pages/ResetPasswordPage'

export const APP_URLS = {
  dashboard: '/dashboard',
  verifyIdentity: 'verify-identity',
  auth_login: '/auth/login',
  auth_logout: '/auth/logout',
  auth_reset_password: '/auth/reset-password/:resetCode',
  verifyDisbursementAccount: 'disbursement-accounts/verify/:token',
  home: '/'
}

interface PageUrl {
  id: number
  internalLink: boolean
  title: string
  url: string
}

// export const WWW_BASE_URL = 'https://sunexchange.com'
export const WWW_BASE_URL = 'https://app.thesunexchange.com'

export const MENU_BAR_URLS: PageUrl[] = [
  { id: 1, internalLink: false, title: 'Home', url: WWW_BASE_URL },
  { id: 2, internalLink: false, title: 'Contact Us', url: `${WWW_BASE_URL}/contact-us` },
  { id: 3, internalLink: true, title: 'Dashboard', url: APP_URLS.dashboard }
]

export const FOOTER_1_URLS: PageUrl[] = [
  { id: 1, internalLink: false, title: 'Home', url: WWW_BASE_URL },
  { id: 2, internalLink: false, title: 'Contact Us', url: `${WWW_BASE_URL}/contact-us` }
]

export const FOOTER_2_URLS: PageUrl[] = [
  { id: 1, internalLink: false, title: 'Legal Disclaimer', url: `${WWW_BASE_URL}/legal-disclaimer` },
  { id: 2, internalLink: false, title: 'Privacy Policy', url: `${WWW_BASE_URL}/privacy-policy` },
  { id: 3, internalLink: false, title: 'Terms of Service', url: `${WWW_BASE_URL}/terms-of-service` },
  { id: 4, internalLink: false, title: 'Vulnerability Disclosure', url: `${WWW_BASE_URL}/vulnerability-disclosure-policy` },
  { id: 5, internalLink: false, title: 'POPIA', url: `${WWW_BASE_URL}/popia-policy` }
]

export const UPDATE_PROFILE_URLS: PageUrl[] = [
  { id: 1, internalLink: false, title: 'Terms of Service', url: `${WWW_BASE_URL}/terms-of-service` },
  { id: 2, internalLink: false, title: 'Privacy Policy', url: `${WWW_BASE_URL}/privacy-policy` },
  { id: 3, internalLink: false, title: '', url: `${WWW_BASE_URL}/member-prohibitions` }
]

const App: React.FC = () => {
  const dispatch = useAppDispatch()

  const theme = createTheme({
    typography: {
      fontFamily: ['Nunito'].join(','),
      fontSize: 14,
      h2: { fontSize: '1.2rem' },
      h3: { fontSize: '1.2rem', fontWeight: 700 },
      h4: { fontSize: '1rem', fontWeight: 700 },
      h5: { fontSize: '1.2rem' },
      h6: { fontSize: '1rem' },
      body1: { fontSize: '1rem' },
      body2: { fontSize: '1rem', fontWeight: 700 }
    },
    palette: {
      // default: {
      //   main: '#fff',
      //   contrastText: '#000'
      // },
      primary: {
        main: '#FAB600',
        // light: '#FAB600',
        // dark: '#002884',
        contrastText: '#fff'
      },
      secondary: {
        main: '#3ba2eb',
        // light: '#3ba2eb',
        // dark: '#ba000d',
        contrastText: '#000'
      }
    },
    components: {
      MuiAccordion: {
        styleOverrides: {
          root: {
            '&.Mui-expanded': {
              margin: '1px 0 0 0 '
            }
          }
        }
      },
      MuiTable: {
        styleOverrides: {
          root: {
            color: 'red'
          }
        }
      }
    }
  })

  // TODO: useEffect?
  const l = getLoginResponseFromLocalStorage()
  if (l !== null) {
    dispatch(authReceiveToken(l))
  }

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* <Route path={APP_URLS.home} element={<Navigate to={APP_URLS.dashboard}/>} /> */}

            <Route path={APP_URLS.auth_login}>
              <Route index element={<AuthLoginPage/>}/>
            </Route>

            <Route path={APP_URLS.auth_reset_password}>
              <Route index element={<ResetPasswordPage/>}/>
            </Route>

            <Route path={APP_URLS.home} element={<ProtectedRoute/>}>
              <Route index element={<Navigate to={APP_URLS.dashboard}/>}/>
              <Route path={APP_URLS.dashboard} element={<DashboardLayout/>}>
                <Route index element={<DashboardHome/>}/>
                {/*<Route path={APP_URLS.verifyIdentity} element={<VerifyIdentityPage />}/>*/}
                <Route path={APP_URLS.verifyDisbursementAccount} element={<VerifyDisbursementAccountPage />}/>
              </Route>

            </Route>

          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
